export default "__VITE_ASSET__DrN233p___"